<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-60">
      <candidate-edit-form ref="candidate-edit-form" header-color="green">
      </candidate-edit-form>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-40">
      <candidate-status-update-form
        ref="candidate-status-update-form"
        header-color="green"
      >
      </candidate-status-update-form>
    </div>
  </div>
</template>
<script>
import CandidateEditForm from "./CandidateUpdateComponent/CandidateEditForm";
import CandidateStatusUpdateForm from "./CandidateUpdateComponent/CandidateStatusUpdateForm";

export default {
  components: {
    CandidateStatusUpdateForm,
    CandidateEditForm
  },
  data() {
    return {
      status: {
        "New form": 10,
        "In progress": 20,
        Possible: 30,
        Applied: 40,
        Dropped: 50
      }
    };
  },
  mounted() {
    this.candidateID = this.$route.params.id;
    this.$store.getCandidate(this.candidateID).then(response => {
      this.$refs["candidate-edit-form"].first_name = response.data.first_name;
      this.$refs["candidate-edit-form"].last_name = response.data.last_name;
      this.$refs["candidate-edit-form"].email = response.data.email;
      this.$refs["candidate-edit-form"].candidate_from =
        response.data.candidate_from;
      this.$refs["candidate-edit-form"].program = response.data.program;
      if (response.data.nationality) {
        this.$refs["candidate-edit-form"].nationality =
          response.data.nationality.id;
      }
      if (response.data.country_of_residence) {
        this.$refs["candidate-edit-form"].country_of_residence =
          response.data.country_of_residence.id;
      }
      this.$refs["candidate-edit-form"].phone_number =
        response.data.phone_number;
      this.$refs["candidate-edit-form"].education_language =
        response.data.education_language;
      this.$refs["candidate-edit-form"].authorized_user =
        response.data.authorized_user.id;

      // Degree
      if (response.data.university_degree === "Associate degree") {
        this.$refs["candidate-edit-form"].university_degree = 1;
      } else if (response.data.university_degree === "Bachelor degree") {
        this.$refs["candidate-edit-form"].university_degree = 2;
      } else if (response.data.university_degree === "Master Non-Thesis") {
        this.$refs["candidate-edit-form"].university_degree = 3;
      } else if (response.data.university_degree === "Master With Thesis") {
        this.$refs["candidate-edit-form"].university_degree = 4;
      } else if (response.data.university_degree === "Phd degree") {
        this.$refs["candidate-edit-form"].university_degree = 5;
      }

      // Type
      if (response.data.university_type === "State") {
        this.$refs["candidate-edit-form"].university_type = 1;
      } else if (response.data.university_type === "Private") {
        this.$refs["candidate-edit-form"].university_type = 2;
      }

      this.$refs["candidate-status-update-form"].result = response.data.result;
      this.$refs["candidate-status-update-form"].note = response.data.note;
      this.$refs["candidate-status-update-form"].status = this.status[
        response.data.status
      ];
    });
  }
};
</script>
